import { render, staticRenderFns } from "./AbsencePlanForm.vue?vue&type=template&id=4932cdfa&scoped=true&"
import script from "./AbsencePlanForm.vue?vue&type=script&lang=js&"
export * from "./AbsencePlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932cdfa",
  null
  
)

export default component.exports